<template>
  <div class="main_center">
    <div class="table_header">
      <div class="pageTitle">信用评价模型库</div>
      <el-tabs @tab-click="handleClick"  v-model="roleType">
        <el-tab-pane
          :key="index"
          :label="item.roleName"
          :name="item.roleCode"
          v-for="(item,index) in roleList"
        ></el-tab-pane>
      </el-tabs>
      <el-tag class="yellowTag" type="warning">
        <div
          style="width:18px;height:18px;position:absolute;top:50%;bottom:50%;transform:translate(-50%, -50%); padding-left:4px;"
        >
          <svg
            t="1664185653876"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2549"
            width="18"
            height="18"
          >
            <path
              d="M234.666667 554.666667H128l85.333333-81.066667L345.6 341.333333l51.2 51.2-81.066667 81.066667H896V554.666667H234.666667z"
              fill="#e6a23c"
              p-id="2550"
            />
          </svg>
        </div>
        <div style="display:inline-block;position:absolute;left:30px;top:0px;">评价方</div>
      </el-tag>
    </div>
    <div style="margin:16px 24px;background:#FFF;position:relative" class="cardTabsBox">
      <el-tabs @tab-click="handleRoleChange" type="card" v-model="evaluatedRoleType">
        <el-tab-pane
          :disabled="roleType==item.roleCode"
          :key="index"
          :label="item.roleName + ' [' + item.count + ']'"
          :name="item.roleCode"
          v-for="(item,index) in roleCountList"
        ></el-tab-pane>
      </el-tabs>
      <el-tag class="blueTag">
        <div
          style="width:18px;height:18px;position:absolute;top:50%;bottom:50%;transform:translate(-50%, -50%); padding-left:4px;"
        >
          <svg
            t="1664185653876"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2549"
            width="18"
            height="18"
          >
            <path
              d="M234.666667 554.666667H128l85.333333-81.066667L345.6 341.333333l51.2 51.2-81.066667 81.066667H896V554.666667H234.666667z"
              fill="#3E8EF7"
              p-id="2550"
            />
          </svg>
        </div>
        <div style="display:inline-block;position:absolute;left:30px;top:0px;">被评价方</div>
      </el-tag>
      <div
        style="min-height:650px;border: 1px solid #e4e7ed;border-top: none;position: relative;text-align: center"
        v-loading.lock="dataListLoading"
      >
        <modelItem
          :selectTreeData.sync="selectTreeData"
          :evaluatedRoleType.sync="evaluatedRoleType"
          :key="item.id"
          :modelForm="item"
          :modelFormIndex="index"
          :roleType.sync="roleType"
          :timeUnitList.sync="timeUnitList"
          @deleteEvalItem="deleteDataList"
          @updateListItem="updateListItem"
          @reloadList="getDataList"
          @reloadTabs="getEvalModelTabs"
          v-for="(item,index) in dataList"
        ></modelItem>
        <el-button
          @click="addDataList()"
          icon="el-icon-plus"
          size="medium"
          style="text-align: center;margin: 24px"
          type="primary"
        >新增评价项</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { isMobile, isIdcard } from "@/utils/validate";
import {
  getRoleList,
  getTimeUnit,
  evalModelTabs,
  getAllEvalIndexTreeList,
  evalModelQueryList
} from "@/server/entEval.js";
import { mapState } from "vuex";
import modelItem from "../components/modelItem/index";
export default {
  components: {
    modelItem
  },
  data() {
    return {
      dataListLoading: false,
      roleType: "",
      evaluatedRoleType: "",
      level: "",
      dataList: [],
      randomKey: Math.random(),
      roleCountList: [],
      timeUnitList: [],
      roleList: [],
      selectTreeData: [],
      form: {
        id: "",
        status: false,
        personType: "",
        participationRights: []
      },
      type: 1,
      timeout: null
    };
  },

  computed: {},
  watch: {},
  created() {
    this.$store.dispatch("dataDictionary/getEvalBusinessTypeList"); //获取评价触发类型
    this.$store.dispatch("dataDictionary/getEvalDefaultValueTypeList"); // 获取评价默认值
    this.getRuleList();
    this.getTimeUnitList();
  },
  activated() {
    this.getDataList();
  },
  methods: {
    getTimeUnitList() {
      getTimeUnit().then(res => {
        if (res.data.code != "1") {
          this.$message.error(res.data.msg);
          return;
        }
        this.timeUnitList = res.data.data;
      });
    },
    getAllEvalIndexTreeListFn() {
      getAllEvalIndexTreeList({
        roleType: this.evaluatedRoleType
      }).then(res => {
        if (res.data.code != "1") {
          this.$message.error(res.data.msg);
          return;
        }
        this.selectTreeData = res.data.data;
      });
    },
    getRuleList() {
      getRoleList().then(res => {
        if (res.data.code != "1") {
          this.$message.error(res.data.msg);
          return;
        }
        this.roleList = res.data.data;
        if (this.roleList.length > 0) {
          let roleType = this.roleList[0].roleCode;
          let evaluatedRoleType = this.roleList[1].roleCode;
          this.roleType = roleType;
          this.evaluatedRoleType = evaluatedRoleType;

          this.getEvalModelTabs();
          this.getDataList();
          this.getAllEvalIndexTreeListFn();
        }
      });
    },
    getEvalModelTabs(roleType) {
      evalModelTabs({
        roleType: roleType || this.roleType
      }).then(res => {
        if (res.data.code != "1") {
          this.$message.error(res.data.msg);
          return;
        }
        this.roleCountList = res.data.data;
      });
    },

    addDataList() {
      this.dataList.push({
        tradeId:"",
        id: "",
        openFlag: 1,
        isEdit: true,
        roleType: this.roleType,
        evaluatedRoleType: this.evaluatedRoleType,
        evaluateCode: "",
        datasetCode: "",
        datasetCodeName: "",
        defaultValueType: "1",
        graininess: "",
        describeContent: "",
        sendType: 2,
        sendSmsFlag: 0,
        showFlag: 0,
        evaluateSmsFlag: 0,
        smsTemplate: "",
        links: [],
        sendTimeInfo: {
          number: "",
          type: "",
          hour: "",
          minute: ""
        },
        endTimeInfo: {
          number: 72,
          type: 1,
          hour: "",
          minute: ""
        }
      });
    },

    updateListItem(index, key, val) {
      this.dataList[index][key] = val;
      this.dataList = JSON.parse(JSON.stringify(this.dataList));
    },
    deleteDataList(index) {
      if (index > -1) {
        this.dataList.splice(index, 1);
      }
    },
    getDataList() {
      // 获取列表数据
      this.dataListLoading = true;
      evalModelQueryList({
        page: 1,
        rows: 1000,
        filter: {
          roleType: this.roleType,
          evaluatedRoleType: this.evaluatedRoleType
        }
      })
        .then(res => {
          let dataRows = res.data.rows || [];
          dataRows.forEach(item => {
            item.openFlag = item.openFlag ? 1 : 0;
            item.sendSmsFlag = item.sendSmsFlag ? 1 : 0;
            item.showFlag = item.showFlag ? 1 : 0;
            item.evaluateSmsFlag = item.evaluateSmsFlag ? 1 : 0;
            item.defaultValueType = item.defaultValueType.toString();
          });
          this.dataList = dataRows;
          this.dataListLoading = false;
        })
        .finally(() => {});
    },

    handleRoleChange(tab, event) {
      this.evaluatedRoleType = tab.name;
      this.getAllEvalIndexTreeListFn();
      this.getDataList();
    },

    handleClick(tab, event) {
      this.roleType = tab.name;
      let index = this.roleList.findIndex(val => val.roleCode == this.roleType);
      if (index == 0 &&this.roleList&& this.roleList.length > 1) {
        this.evaluatedRoleType = this.roleList[1].roleCode;
      } else if (this.roleList.length > 0) {
        this.evaluatedRoleType = this.roleList[0].roleCode;
      }
      this.getEvalModelTabs();
      this.getDataList();
    },

    getDic(type) {
      // 获取字典
      this.$http.get("/sys/dictData/getList?type=" + type).then(res => {
        if (res.data.code === "1") {
          switch (type) {
            case "participationRights":
              this.authList = res.data.data;
              break;
          }
        }
      });
    },
    backRouter() {
      this.$refs["form"].resetFields();
      this.form = {};
      Object.assign(this.$data.form, this.$options.data().form);
      this.tabsCloseCurrent();
      this.$router.push({ name: "personRegister_list" });
    },
    submit(form) {
      let formData = JSON.parse(JSON.stringify(this.form));
      formData.participationRights = formData.participationRights.join(",");
      this.$refs[form].validate(valid => {
        if (valid) {
          this.$httpReq
            .post("/openEvalPersonRegister/save", formData)
            .then(res => {
              if (res.data.code == 1) {
                this.$message.success("保存成功");
                this.tabsCloseCurrent();
                this.$router.push({ name: "personRegister_list" });
              } else {
                this.$message.error(res.data.msg);
              }
            });
        } else {
          this.$message.error("必填字段没有填写完成,请填写完成");
        }
      });
    },

    handlePersonType() {
      // this.form.personType = "";
    },
    handleDeptType(data) {
      this.form.deptCode = data.value;
      this.form.deptName = data.label;
    },
    uploadSuccess(fileType) {
      this.$refs["form"].clearValidate(["attachments" + fileType]);
    }
  }
};
</script>

<style lang="scss" scoped>

.table_header {
  position: relative;
  background: #ffffff;
  padding: 0 24px;
  padding-top:24px;
//   box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  .pageTitle{
        font-size: 18px;
        font-weight: 600;
        color: #000000; 
        height: 40px; 
    }
  .yellowTag {
    width: 75px;
    position: absolute;
    right: 30px;
    bottom: 10px;
  }
  
}
.blueTag {
    width: 90px;
    position: absolute;
    right: 10px;
    top: 6px;
  }
</style>